<template>
    <div class="whole_dialog">
        <el-dialog
            @closed="closeDialog"
            append-to-body
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :title="$t('LnkWxImage.title')"
            :visible.sync="coverDialog"
            width="720px"
            top="20px"
            center>
            <div class="whole_form whole_img lnk-wx-image clearfix">
                <el-form ref="coverform" v-model="coverform" @submit.native.prevent>
                    <!--图片左边分组-->
                    <div class="imgform_left">
                        <div class="imgform_left_box">
                            <el-radio-group v-model="coverform.groupstring"  size="mini" @change="filtergroupChange">
                                <el-radio-button v-for="(items, index) in group" :label="items.id" :key="index">{{items.groupName+'('+items.count+')'}}</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <!--右边布局-->
                    <div class="imgform_right">
                        <div class="box-opera">
<!--                            <div class="header-right clearfix">-->
<!--                                <lnk-upload-button-img-->
<!--                                    class="uploadButton"-->
<!--                                    head-id="11111"-->
<!--                                    :image-size="8192"-->
<!--                                    :module-type="moduleType"-->
<!--                                    @uploadsuccess="imgUploadSuccess">-->
<!--                                </lnk-upload-button-img>-->
<!--                            </div>-->
                            <div class="header-left clearfix">
                                <div class="left-ipt">
                                    <el-input
                                        :placeholder="$t('LnkWxImage.searchPlaceholder')"
                                        clearable
                                        v-model="imgmaterial.filename"
                                        @keyup.enter.native="searchImg">
                                    </el-input>
                                </div>
                                <div class="left-ipt left-search clearfix">
                                    <el-button type="primary" @click="searchImg" style="width:68px;">查询</el-button>
                                </div>
                            </div>
                        </div>
                        <!--图片展示区域-->
                        <div class="img-list clearfix">
                            <div class="imglist-item" v-for="(items,key) in imgmaterial.imglist" :key="key" @click="selectimg(items,key)" :class="(key + 1) % 4==0?'imglist-noright':''">
                                <img :src="items.tempMaterialUrl + srcEnd" alt="" />
                                <div class="layer" v-bind:class="{showorhide:key==currents}">
                                    <i class="el-icon-check"></i>
                                </div>
                                <p class="img-name">{{items.filename}}</p>
                            </div>
                        </div>
                        <div class="block" v-if="imgmaterial.imglist.length!=0">
                            <el-pagination layout="prev, pager, next"
                                           :total="imgmaterial.pageInf.totalcount"
                                           :page-size="12"
                                           @size-change="materialSizeChange"
                                           @current-change="materialCurrentChange">
                            </el-pagination>
                        </div>
                        <div v-else class="fodder">
                            <div width="80%">{{$t('LnkWxImage.noDescribe')}}</div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer dialogbutton">
                <el-button @click="cancelImg" style="background-color:#fff;border-color:#1F74FF ;color:#1F74FF ;">{{$t('global.cancel')}}</el-button>
                <el-button type="primary" @click="confirmimg" :disabled="confirmDisabled">{{$t('global.confirm')}}</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>

/**
     @name:微信素材选择组件  ps：只能输入数字 小数点
     @createdby:常九福
     @example template:
     <lnk-wx-image
     :imgvisible.sync = "coverDialog"
     @change = "getSelectImg"
     ></lnk-wx-image>
     methods:{
       getSelectImg(val){
            val 就是所选择的图片对象
       }
     }

     @props:
     conf:Array,  //页面加载，获取列表字段配置的数组，用于多条件组合查询字段查询
     classname:String,//查询条件弹出框主体颜色，设置有dms和crm两种颜色 默认为dms的:dialogdms  可选值：dialogdms  dialogcrm

     **/

const ungroupedId='2';
export default {
    name: 'lnk-wx-image',
    data: function(){
        return {
            coverDialog: false, // 是否展示图片弹出框
            currents: -1, // 控制图片的选中状态
            group: [], // 微信素材图片分组
            coverform: {// 弹出框图片数据存贮
                groupstring: ''
            },
            groupId: ungroupedId, // 微信分组id缓存 默认上传至未分组
            imgmaterial: {
                filename: '',
                imglist: [], // 图片列表分组
                pageInf: {// 素材分页
                    page: 1,
                    pageSize: 12,
                    totalcount: 0
                },
                imgthubs: {}
            },
            moduleType: 'WXTHUBMS',
            srcEnd: '?' + Math.random(),
            confirmDisabled: false // 确认按钮禁用
        };
    },
    props: {
        imgvisible: {// 是否显示
            type: Boolean,
            default: false
        },
        wxid: {// 微信id
            type: String,
            default: ''
        },
		oauth: {type: String, default: window.CURRENT_ORIGIN_TOP.oauth}
    },
    watch: {
        imgvisible: {
            immediate: true,
            handler: function (val){
                this.coverDialog = Boolean(val);
                if(this.coverDialog){
                    this.confirmDisabled = false;
                    this.getgroupdata(); // 获取图片分组
                    this.filtergroup('W-001');// 默认加载所有图片
                }
            }
        }
    },
    methods: {

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:getgroupdata
         *@description:获取图片分组
         **/
        getgroupdata() { // 素材图片分组
            axios1.post(appCtx.ctxPath + `/action/${LinkVue.prefixUrl}/imggroup/queryByExamplePage`, {
                wxId:this.wxid,
                page: 1,
                rows: 100,
                oauth: this.oauth,
                pageFlag: false,
                totalFlag: true
            }).then( (response)=> {
                var grouparr = response.data.rows;
                this.group = grouparr;
                // 默认选中第一个
                var grouparray = this.group[0];
                var groupstring = grouparray.id;
                this.coverform.groupstring = groupstring;
            }).
                catch(function (error) {
                    this.$nav.error(error.result);
                });
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:selectimg
         *@para:item 选择图片的对象  index 图片在数组中的下标位置
         *@description: 选中图片
         **/
        selectimg(item, index) {
            this.currents = index;
            // 选中素材id以及url存贮
            this.imgmaterial.imgthubs = item;
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:confirmimg
         *@description: 确定展示数据
         **/
        confirmimg() { // 确定选择图片把图片id以及url赋值给editform
            if (!this.imgmaterial.imgthubs) {
                this.$message({
                    message: '请至少选择一张素材图片',
                    type: 'warning',
                    duration: 1500
                });
                return false;
            }
            if(this.confirmDisabled){
                return;
            }
            this.confirmDisabled = true;
            this.$emit('change', this.imgmaterial.imgthubs); // 把选择的数据传递到组件外边
            this.imgmaterial.imgthubs = {};
            this.coverDialog = false;
            this.$emit('update:imgvisible', false);
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:cancelImg
         *@description: 取消选择图片
         **/
        cancelImg() {
            this.currents = -1;
            this.imgmaterial.imgthubs = {};
            this.$emit('update:imgvisible', false);
        },
        /**
         *@createdBy 常九福
         *@date 2018/12/26
         *@methods:closeDialog
         *@description:关闭弹出框，刷新组件数据
         **/
        closeDialog(){
            this.currents = -1;
            this.imgmaterial.imgthubs = {};
            this.$emit('update:imgvisible', false);
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:searchImg
         *@description: 搜搜图片
         **/
        searchImg() { // 搜索图片
            this.imgmaterial.pageInf.page = 1;
            this.filtergroup(this.groupId);
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:materialSizeChange
         *@para:val 每页显示多少条
         *@description:根据一页显示多少条筛选数据
         **/
        materialSizeChange(val) {
            this.imgmaterial.pageInf.pageSize = val;
            this.imgmaterial.pageInf.page = 1;
            this.filtergroup(this.groupId);
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:materialCurrentChange
         *@para:val 点击具体每一页
         *@description:根据点击某一页显示图片数据
         **/
        materialCurrentChange(val) { // 素材在第几页
            this.imgmaterial.pageInf.page = val;
            this.filtergroup(this.groupId);
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:filtergroupChange
         *@para: val 点击每一个图片分组的对象
         *@description: 根据图片分组筛选数据
         **/
        filtergroupChange(val) {
            this.imgmaterial.pageInf.page = 1;
            this.filtergroup(val);
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:filtergroup
         *@para:val 图片分组id
         *@description: 对筛选条件做处理
         **/
        filtergroup(val) {
            this.groupId = val;
            var filteraw = [];
            if (val == 'W-001') {
                filteraw = [
                    {id: 'wxId', property: 'wxId', operator: 'LIKE', value: this.wxid},
                    {id: 'filename', property: 'filename', operator: 'LIKE', value: this.imgmaterial.filename}
                ];
                this.loadingImg(filteraw);
            } else {
                filteraw = [
                    {id: 'wxId', property: 'wxId', operator: 'LIKE', value: this.wxid},
                    {id: 'groupId', property: 'groupId', operator: 'LIKE', value: val},
                    {id: 'filename', property: 'filename', operator: 'LIKE', value: this.imgmaterial.filename}
                ];
                this.loadingImg(filteraw);
            }
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:loadingImg
         *@para:filteraw 筛选条件
         *@description：加载图片
         **/
        loadingImg(filteraw) { // 加载图片
            var that = this;
            axios1.post(appCtx.ctxPath + `/action/${LinkVue.prefixUrl}/wximage/queryByExamplePage`, {
                page: that.imgmaterial.pageInf.page,
                rows: that.imgmaterial.pageInf.pageSize,
                oauth: this.oauth,
                pageFlag: true,
                totalFlag: true,
                sort: 'created',
                order: 'desc',
                filtersRaw: JSON.stringify(filteraw)
            }).then(function (response) {
                var allimg = response.data.rows;
                that.currents = -1;
                that.imgmaterial.imglist = allimg;
                that.imgmaterial.pageInf.totalcount = response.data.total;
            }).
                catch(function (error) {
                    that.$nav.error(error.result);
                });
        },

        /**
         *@createdBy 常九福
         *@date 2018/11/20
         *@methods:imgUploadSuccess
         *@para:data 上传图片成功返回的的参数
         *@description:添加素材
         **/
        imgUploadSuccess(data) { // 图文编辑上传图片返回图片id
            var groupid = this.groupId;
            if(groupid == 'W-001' || groupid == ungroupedId){
                groupid = ungroupedId;
            }else{
                groupid = this.groupId;
            }
            if (data.success) {
                var that = this;
                var newRow = data.newRow;
                axios1.post(appCtx.ctxPath + `/action/${LinkVue.prefixUrl}/wximage/uploadImg`, {
                    filename: newRow.attachmentName,
                    groupId: groupid,
                    tempMaterialUrl: newRow.id,
                    wxId: that.wxid
                }).then(function (response) {
                    if (response.data.success == true) {
                        that.imgmaterial.imglist.unshift(response.data.newRow);
                        if (that.imgmaterial.imglist.length > that.imgmaterial.pageInf.pageSize) {
                            that.imgmaterial.imglist = that.imgmaterial.imglist.slice(0, that.imgmaterial.pageInf.pageSize);
                        }
                        that.currents = 0;
                        that.imgmaterial.imgthubs.thumbMediaId = response.data.newRow.thumbMediaId;
                        that.imgmaterial.imgthubs.tempMaterialUrl = response.data.newRow.tempMaterialUrl;
                        that.group.forEach(function (item) {
                            if (that.groupId != '' && that.groupId != undefined && that.groupId != 'W-001' && that.groupId != ungroupedId) {
                                if (item.id == that.groupId) {
                                    item.count += 1;
                                }
                            } else {
                                if (item.id == ungroupedId) {
                                    item.count += 1;
                                }
                            }
                            if (item.id == 'W-001') {
                                item.count += 1;
                            }
                        });
                        that.searchImg();
                        that.$message({
                            message: '上传成功',
                            type: 'success',
                            duration: 1000
                        });
                    } else {
                        if (response.data.msg) {
                            that.$nav.error(response.data.msg);
                        } else {
                            that.$nav.error('上传失败');
                        }
                    }
                }).
                    catch(function (error) {
                        that.$nav.error(error.result);
                    });
            }
        }
    }
};
</script>

<style scoped>
    /*图片素材组件上传样式*/
    *{
        padding:0;
        margin:0;
    }
    .clear{
        clear:both;
        font-size:1px;
        height:0;
        visibility:hidden;
        line-height:0;
    }
    .clearfix:after{
        content:"";
        display:block;
        clear:both;
    }
    .clearfix{
        zoom:1;
    }
    img{
        border:0;
        vertical-align:middle;
    }
    .lnk-wx-image .el-dialog__body{
        background: #F6F7FB;
        padding: 16px 16px 16px 20px;
    }
    .lnk-wx-image .imgform_left{
        float:left;
        width: 148px;
        border: 1px solid #D9D9D9;
        padding: 14px 0;
        background: #fff;
        margin-right:16px;
        height: 405px;
        overflow: hidden;
    }
    .lnk-wx-image .imgform_left_box{
        width: 168px;
        overflow-y: scroll;
        height: 405px;
    }
    /*左边label布局*/
    .lnk-wx-image .imgform_left /deep/ .el-radio-button{
        display: block;
    }
    .lnk-wx-image .imgform_left /deep/ .el-radio-button__inner{
        margin-bottom: 5px;
        padding:10px 15px;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        border:0
    }
    .lnk-wx-image .imgform_right{
        float:right;
        width:470px;
    }
    .lnk-wx-image .box-opera{
        height: 28px;
        margin-bottom: 10px;
    }
    .lnk-wx-image .imglist-item{
        float: left;
        width: 108px;
        height: 112px;
        border: 1px solid #D9D9D9;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        position: relative
    }
    .lnk-wx-image .imglist-noright{
        margin-right:0px;
    }
    .lnk-wx-image .imglist-item img{
        width: 108px;
        height: 88px;
    }
    .lnk-wx-image .imglist-item .layer{
        display:none;
        position: absolute;
        width: 108px;
        height: 112px;
        left: 0px;
        top: 0px;
        background: rgba(56,65,97,0.59);
    }
    .lnk-wx-image .imglist-item .showorhide{
        display:block!important;
    }
    .lnk-wx-image .imglist-item .el-icon-check{
        text-align: center;
        font-size: 60px!important;
        position: absolute;
        left: 25px;
        top: 30px;
        color: #fff;
    }
    .lnk-wx-image .imglist-item .img-name{
        width: 108px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0 8px;
    }
    .lnk-wx-image .el-radio-button--mini .el-radio-button__inner{
        padding:12px 15px;
    }
    .lnk-wx-image .imgform_right .left-ipt{
        width:300px;
    }
    .lnk-wx-image .imgform_right .el-input{
        width:300px;
    }
    .lnk-wx-image .imgform_right .left-search{
        width: 68px;
    }
    .lnk-wx-image .imgform_right .left-search .el-button,
    .lnk-wx-image .header-right .el-button{
        width:72px;
        height:28px;
        float:left;
        padding:0px;
    }
    .lnk-wx-image .imgform_right .header-right{
        float:right;
        width:auto;
    }
    .lnk-wx-image .imgform_right .header-left,
    .lnk-wx-image .imgform_right .header-left /deep/ div{
        float:left;
    }
    .lnk-wx-image .imgform_right .header-left /deep/ .el-input__inner{
        height:28px;
        line-height:28px;
    }
    .lnk-wx-image .imgform_right .header-right{
        margin-left:15px;
    }
    .fodder{
        width: 100%;
        height: 300px;
        color: rgb(133, 142, 150);
        font-size: 14px;
        font-weight: 400;
    }
    .fodder div:nth-child(1){
        margin-left: 185px;
        height: 398px;
        line-height: 27;
    }

</style>
